var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5625,
    width: 40,
    height: 40,
    rx: 20,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5501C13 12.5789 13 12.0933 13.2025 11.8256C13.3789 11.5925 13.6485 11.4482 13.9404 11.4307C14.2754 11.4107 14.6795 11.6801 15.4875 12.2188L26.0031 19.2292C26.6708 19.6743 27.0046 19.8968 27.1209 20.1774C27.2227 20.4226 27.2227 20.6982 27.1209 20.9435C27.0046 21.224 26.6708 21.4466 26.0031 21.8917L15.4875 28.9021C14.6795 29.4408 14.2754 29.7101 13.9404 29.6901C13.6485 29.6727 13.3789 29.5284 13.2025 29.2952C13 29.0275 13 28.542 13 27.5708V13.5501Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIcon);
export default __webpack_public_path__ + "static/media/videoPlayIcon.38a4a8a50f97bb93ecda73b16729f51c.svg";
export { ForwardRef as ReactComponent };